import createLucideIcon from '../createLucideIcon';
import type { LucideIconNode, LucideIconData } from '../types';

export const __iconData: LucideIconData = {
  name: 'zodiac-ophiuchus',
  size: 24,
  node: [
    ['path', { d: 'M3 10A6.06 6.06 0 0 1 12 10 A6.06 6.06 0 0 0 21 10', key: '13lfmc' }],
    ['path', { d: 'M6 3v12a6 6 0 0 0 12 0V3', key: '1jnivp' }],
  ],
};

/**
 * @deprecated Access `__iconData` instead.
 */
export const __iconNode: LucideIconNode[] = __iconData.node;

/**
 * @component @name ZodiacOphiuchus
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMyAxMEE2LjA2IDYuMDYgMCAwIDEgMTIgMTAgQTYuMDYgNi4wNiAwIDAgMCAyMSAxMCIgLz4KICA8cGF0aCBkPSJNNiAzdjEyYTYgNiAwIDAgMCAxMiAwVjMiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/zodiac-ophiuchus
 * @see https://lucide.dev/guide/packages/lucide-react - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ZodiacOphiuchus = createLucideIcon(__iconData);

export default ZodiacOphiuchus;
